import { yunpb } from "@/types/protobuf";
import request from "@js/web/request/Axios";

export const apiCheckVipPageInfo = (
  data: pro.yunpb.ICheckVipPageInfoReq = {}
): Promise<pro.yunpb.ICheckVipPageInfoRes> => {
  return request({
    reqDesction: "CheckVipPageInfoReq",
    resDesction: "CheckVipPageInfoRes",
    funcName: "CheckVipPageInfo",
    serverName: "chikii.vip.VipExtObj",
    data,
  });
};

// 签到领取奖励
export const apiGetVipSignInReward = (
  data: pro.yunpb.ICheckVipPageInfoReq = {}
): Promise<pro.yunpb.ICheckVipPageInfoRes> => {
  return request({
    reqDesction: "GetVipRewardReq",
    resDesction: "GetVipRewardRes",
    funcName: "GetVipSignInReward",
    serverName: "chikii.vip.VipExtObj",
    data,
  });
};

// 获取周免游戏
export const apiGetHomepageModuleList = (
  data: pro.yunpb.IGetHomepageModuleListReq = {}
): Promise<pro.yunpb.IGetHomepageModuleListRes> => {
  return request({
    reqDesction: "GetHomepageModuleListReq",
    resDesction: "GetHomepageModuleListRes",
    funcName: "GetHomepageModuleList",
    serverName: "chikii.web.WebExtObj",
    data,
  });
};

// 获取会员游戏模块
export const apiGetHomepageModule = (
  data: pro.yunpb.IGetHomepageModuleReq = {}
): Promise<pro.yunpb.IGetHomepageModuleRes> => {
  return request({
    reqDesction: "GetHomepageModuleReq",
    resDesction: "GetHomepageModuleRes",
    funcName: "GetHomepageModule",
    serverName: "chikii.web.WebExtObj",
    data,
  });
};

// 发现页-顶部导航栏
export const apiGetDiscoveryNavigation = (
  data: pro.yunpb.IGetDiscoveryNavigationReq = {}
): Promise<pro.yunpb.IGetDiscoveryNavigationRes> => {
  return request({
    reqDesction: "GetDiscoveryNavigationReq",
    resDesction: "GetDiscoveryNavigationRes",
    funcName: "GetDiscoveryNavigation",
    serverName: "chikii.web.WebExtObj",
    data,
  });
};
